import SubscriptionValidity from './SubscriptionValidity';

export default class Subscription {
	systemModules: Set<string>;

	validity: SubscriptionValidity;

	deactivatedTime: Date | null;

	constructor(systemModules: Set<string>, validity: SubscriptionValidity, deactivatedTime: Date | null) {
		this.systemModules = systemModules;
		this.validity = validity;
		this.deactivatedTime = deactivatedTime;
	}
}
